// tslint:disable:max-line-length

import React from 'react';

export const UtilityFilter = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M1,0v2l5.5,5v9l3-4V7L15,2V0H1z" />
    </svg>
  );
};
